"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const Input = (0, _styled.default)("input")`
    opacity: 0;
    user-select: none;

    // For screen readers, the focus ring treatment is sometimes automatically applied to the input
    // element and we don't control it. In this case, it's nice to have the input take up the same
    // amount of space as the checkbox.
    position: absolute;
    inset: 0;
    margin: 0;
    padding: 0;

    // Bring the input to the front so that it can receive mouse events.
    z-index: 1;

    cursor: pointer;

    &[aria-disabled="true"] {
        cursor: not-allowed;
    }

    &:focus {
        outline: none !important;
    }
`;
exports.Input = Input;
//# sourceMappingURL=Input.js.map